import { createSlice } from "@reduxjs/toolkit";

const cancellationFilterSlice = createSlice({
  name: "cancellationFilter",
  initialState: {
    status: null,
    search: null,
  },
  reducers: {
    setCancellationFilter: (state, action) => {
      state.status = action.payload.status || null;
      state.search = action.payload.search || null;
    },

    clearCancellationFilters: (state) => {
      state.status = null;
      state.search = null;
    },
  },
});

export const { setCancellationFilter, clearCancellationFilters } = cancellationFilterSlice.actions;

export const selectCancellationState = (state) => state.cancellationFilter;

export default cancellationFilterSlice.reducer;
